/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetQuartersQuery } from '../../models/get-quarters-query';
import { GetQuartersQueryResult } from '../../models/get-quarters-query-result';

export interface ApiProjectGetQuartersPost$Plain$Params {
      body?: GetQuartersQuery
}

export function apiProjectGetQuartersPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetQuartersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetQuartersQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetQuartersPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetQuartersQueryResult>;
    })
  );
}

apiProjectGetQuartersPost$Plain.PATH = '/api/Project/GetQuarters';
